module.exports = __webpack_public_path__ + "37744ee2c97d083ffc20d545692ce53e.png";